export function playAudio() {
    $('.icon-play-audio').click(function () {
        event.stopPropagation();
        var audioUrl = $(this).attr('data-audio');
        var $this = $(this);
        var existingAudio = $this.data('audioElement');

        // If the clicked audio is already playing, stop it
        if (existingAudio && $this.data('playing')) {
            existingAudio.pause();
            existingAudio.currentTime = 0; // Reset audio to start
            $this.removeClass('is-playing');
            $this.data('playing', false);
            $this.removeData('audioElement');
            return;
        }

        // Stop all other playing audios
        $('.icon-play-audio').each(function () {
            var $other = $(this);
            if ($other.data('playing')) {
                var otherAudio = $other.data('audioElement');
                if (otherAudio) {
                    otherAudio.pause();
                    otherAudio.currentTime = 0;
                }
                $other.removeClass('is-playing');
                $other.data('playing', false);
                $other.removeData('audioElement');
            }
        });

        // Play the new audio
        var audio = new Audio(audioUrl);
        $this.data('audioElement', audio);
        audio.play().catch(function (error) {
            console.error("Audio playback failed:", error);
        });
        $this.addClass('is-playing');
        $this.data('playing', true);

        // Reset when audio ends
        audio.onended = function () {
            $this.removeClass('is-playing');
            $this.data('playing', false);
            $this.removeData('audioElement');
        };
    });
}
